<template>
  <StudioMultiSelect
    v-model="gendersSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
  >
    <template v-slot:selection="{item, index}">
      <v-chip
        v-if="index < minimumFilterView"
        small
      >
        <span>{{ item.text }}</span>
      </v-chip>
      <span
        v-if="index === minimumFilterView"
        class="grey--text caption"
      >
        (+{{ gendersSelected.length - minimumFilterView }} {{ message }})
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import genderModel from '@/mixins/gender-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';

export default {
  name: 'GenderFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    genderModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      label: 'Gênero',
      placeholder: 'Todos',
      minimumFilterView: 1,
    };
  },
  computed: {
    gendersSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newGenders = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && typeof (newValue[0]) === 'object') {
          newGenders = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newGenders,
        });
      },
    },
    selectItems() {
      return this.genders.map(gender => {
        const genderObj = this.getGenderObj(gender);
        return {
          text: genderObj.name,
          value: genderObj.value,
        };
      });
    },
    message() {
      return this.gendersSelected.length - this.minimumFilterView === 1 ? 'outro' : 'outros';
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
